var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rb-auth-layout"},[_c('div',{staticClass:"rb-auth-shell"},[_c('AuthForm',{on:{"afterLogin":_vm.afterLogin}})],1),_c('AuthTestimonialPanel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }